{
  "name": "@ns/public-ledger-credit-transfer-failed",
  "version": "1.1.0",
  "description": "A company's paid nodeStream credits couldn't be delivered after 3 attempts, and automatic retries have stopped. The PUBLIC_LEDGER team completes it with transfer-completed (the delivery runs again now). refunded is completed by public-ledger-credits-confirm-refund once Stripe shows the payment refunded by hand (at least the owed credits' share): the purchase is then set to REFUNDED and nothing more is owed.",
  "inputs": {},
  "outcomes": {
    "transfer-completed": {},
    "refunded": {
      "serverOnly": true
    }
  }
}
